import { useMemo } from 'react';

import { useIsDDFeatureFlagEnabled } from '@/core/data-dog';
import { FindingsByOrgan as FindingsByOrganModel } from '@/shared/model';
import { useDefaultFindingStore, useFindingStore } from '@/store';

import { useFctReport } from './use-fct-report.hook';
import { useReportFindings } from './use-report-findings.hook';

interface FindingsByOrgan {
  defaultFindings: FindingsByOrganModel;
  findings: FindingsByOrganModel;
}

export function useFindingsByOrgan(): FindingsByOrgan {
  const isRqFindingsEnabled = useIsDDFeatureFlagEnabled('FCT_RQ_FINDINGS');
  const { report } = useFctReport();
  const { defaultFindings, findings } = useReportFindings(report?.uuid, {
    enabled: isRqFindingsEnabled,
  });

  const storeFindings = useFindingStore((state) => state.findings);
  const storeDefaultFindings = useDefaultFindingStore((state) => state.defaultFindings);

  return useMemo(
    () => ({
      defaultFindings: isRqFindingsEnabled ? defaultFindings : storeDefaultFindings,
      findings: isRqFindingsEnabled ? findings : storeFindings,
    }),
    [isRqFindingsEnabled, defaultFindings, findings, storeDefaultFindings, storeFindings],
  );
}
